/// <reference path="../../typings/browser.d.ts" />

namespace Application.Common {
    'use strict';

    export class ValidationUtils {

        /**
         * Hack to add the parsley warning classes in case the value of an input is already in use
         *
         * @param name name of the input
         * @param show boolean to indicate if we should show or hide the message
         * @param value value to show in the error message
         */
        public static toggleParsleyWarningClasses(name: string, show: boolean, value: string): void {
            let element: JQuery = $('[name="' + name + '"]');
            let wrapper: JQuery = element.parent();
            let parsleyRow: JQuery = wrapper.parent();
            if (show) {
                element.removeClass('md-input-success').addClass('md-input-danger');
                wrapper.removeClass('md-input-wrapper-success').addClass('md-input-wrapper-danger');
                if (parsleyRow.find('.parsley-errors-list').find('.parsley-wrong').length === 0) {
                    parsleyRow.append(
                        `<div class="parsley-errors-list filled parsley">
                            <span class="parsley-wrong">` + value + ` already in use.</span>
                        </div>`,
                    );
                }
            } else {
                if (parsleyRow.find('.parsley-errors-list').find('.parsley-wrong').length !== 0) {
                    parsleyRow.find('.parsley-errors-list').find('.parsley-wrong').remove();
                    if (parsleyRow.find('.parsley-errors-list').length === 0) {
                        element.addClass('md-input-success').removeClass('md-input-danger');
                        wrapper.removeClass('md-input-wrapper-danger').addClass('md-input-wrapper-success');
                    }
                }
            }
        }
    }
}